// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../public/arrow-down.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.product-card-line__single-info, .product-card-recap__title {
  font-family: "Jost", sans-serif;
  font-size: 12px;
  line-height: 18px;
  letter-spacing: 0.04em;
}

.product-card__price, .product-card__title, .product-card-recap__content, .product-card__qty-selector input[type=text] {
  font-family: "Jost", sans-serif;
  font-size: 14px;
  line-height: 24px;
  letter-spacing: 0.01em;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.product-card__container {
  position: relative;
  width: calc(100% - 62px);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  margin-left: auto;
}
.product-card__container:not(:first-child) {
  margin-top: 73px;
}
@media screen and (min-width: 1025px) {
  .product-card__container {
    width: 100%;
    max-width: 723px;
    flex-direction: row;
    margin-left: auto;
  }
  .product-card__container:not(:first-child) {
    margin-top: 57px;
  }
}
.product-card__container.hidden {
  display: none;
}
.product-card__checkbox {
  position: absolute;
  top: 0;
  left: -51px;
  padding-top: 50%;
}
@media screen and (min-width: 1025px) {
  .product-card__checkbox {
    position: static;
    padding-top: 0;
  }
}
.product-card__checkbox input[type=checkbox] {
  display: none;
}
.product-card__checkbox input[type=checkbox]:disabled + label {
  margin: 0;
  display: none;
}
.product-card__checkbox input[type=checkbox]:checked + label::after {
  transform: translate(-50%, -100%) scale(1);
}
@media screen and (min-width: 1025px) {
  .product-card__checkbox input[type=checkbox]:checked + label::after {
    transform: translateY(-50%) scale(1);
  }
}
.product-card__checkbox label {
  width: 0;
  height: 0;
  margin: 0;
}
@media screen and (min-width: 1025px) {
  .product-card__checkbox label {
    position: relative;
    margin-right: 59px;
  }
}
.product-card__checkbox label::before {
  content: "";
  position: absolute;
  top: 100%;
  left: 100%;
  width: 16px;
  height: 16px;
  display: block;
  border: 1px solid #0f0f0f;
  transform: translate(-50%, -100%);
  cursor: pointer;
}
@media screen and (min-width: 1025px) {
  .product-card__checkbox label::before {
    top: 0;
    left: 0;
    width: 18px;
    height: 18px;
    transform: translateY(-50%);
  }
}
.product-card__checkbox label::after {
  content: "";
  position: absolute;
  top: calc(100% - 5px);
  left: 100%;
  width: 8px;
  height: 8px;
  display: block;
  background-color: #0f0f0f;
  transform: translate(-50%, -100%) scale(0);
  transition: transform 0.35s;
  cursor: pointer;
}
@media screen and (min-width: 1025px) {
  .product-card__checkbox label::after {
    top: 0;
    left: 0;
    left: 6px;
    transform: translateY(-50%) scale(0);
  }
}
.product-card__image {
  width: 100%;
  margin-bottom: 14px;
  flex-basis: auto;
  flex-shrink: 0;
  flex-grow: 0;
}
@media screen and (min-width: 1025px) {
  .product-card__image {
    width: 264px;
    margin-bottom: 0;
    margin-right: 41px;
  }
}
.product-card__image figure {
  position: relative;
  overflow: hidden;
  padding-top: 100%;
}
.product-card__image figure img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
}
.product-card__details {
  width: 100%;
}
@media screen and (min-width: 1025px) {
  .product-card__details {
    width: auto;
  }
}
.product-card__meta {
  flex-basis: auto;
  flex-shrink: 0;
  flex-grow: 0;
}
.product-card__inputs {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  margin-top: 47px;
  transition: height 0.35s 0s, opacity 0.25s 0.35s;
}
@media screen and (min-width: 1025px) {
  .product-card__inputs {
    margin-top: 42px;
  }
}
.product-card__inputs.hidden {
  display: none;
}
.product-card__inputs select {
  appearance: none;
  width: 361px;
  max-width: 100%;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-size: 10px 6px;
  background-position: calc(100% - 5px) calc(50% - 3px);
  margin-bottom: 32px;
  cursor: pointer;
}
.product-card__inputs input[type=text] {
  width: 361px;
  max-width: 100%;
}
.product-card__qty-selector {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: 32px;
}
.product-card__qty-selector input[type=text] {
  text-align: center;
  appearance: none;
  width: 50px;
  padding: 0;
  border: 0;
  outline: 0;
}
.product-card__qty-change {
  background-color: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 24px;
  width: 24px;
  padding: 0;
  border: 0;
  outline: 0;
  margin: 0;
  cursor: pointer;
}
.product-card__qty-change:first-of-type {
  margin-right: 4px;
}
.product-card__qty-change:last-of-type {
  margin-left: 4px;
}
.product-card__qty-change:disabled {
  pointer-events: none;
  opacity: 0.5;
}
.product-card__qty-change svg {
  pointer-events: none;
}
.product-card__inputs-recap {
  margin-top: 53px;
}
@media screen and (min-width: 1025px) {
  .product-card__inputs-recap {
    margin-top: 32px;
  }
}
.product-card__inputs-recap.hidden {
  display: none;
}
.product-card__recap:not(:first-child) {
  margin-top: 32px;
}
@media screen and (min-width: 1025px) {
  .product-card__recap:not(:first-child) {
    margin-top: 16px;
  }
}
.product-card-recap__title {
  color: #8c8c8c;
  margin-bottom: 8px;
}
.product-card-recap__content {
  font-size: 16px;
}
.product-card__title {
  font-weight: 700;
  line-height: 17px;
}
.product-card__price {
  line-height: 24px;
  margin-top: 8px;
}
.product-card__line-info {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-top: 12px;
}
.product-card-line__single-info {
  display: flex;
  align-items: stretch;
  justify-content: flex-start;
}
.product-card-line__single-info:not(:last-child) {
  margin-right: 10px;
}
.product-card-line__single-info:not(:last-child)::after {
  content: "";
  width: 1px;
  display: block;
  background-color: #0f0f0f;
  margin-left: 10px;
}`, "",{"version":3,"sources":["webpack://./src/common.scss","webpack://./src/components/ProductCard/ProductCard.scss"],"names":[],"mappings":"AAcA;EACE,+BAbe;EAcf,eAAA;EACA,iBAAA;EACA,sBAAA;ACbF;;ADgBA;EACE,+BApBe;EAqBf,eAAA;EACA,iBAAA;EACA,sBAAA;ACbF;;AD8BA;EACE;IACE,uBAAA;EC3BF;ED6BA;IACE,yBAAA;EC3BF;AACF;AAlBE;EACE,kBAAA;EACA,wBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,2BAAA;EACA,iBAAA;AAoBJ;AAlBI;EACE,gBAAA;AAoBN;AAjBI;EAbF;IAcI,WAAA;IACA,gBAAA;IACA,mBAAA;IACA,iBAAA;EAoBJ;EAlBI;IACE,gBAAA;EAoBN;AACF;AAjBI;EACE,aAAA;AAmBN;AAfE;EACE,kBAAA;EACA,MAAA;EACA,WAAA;EACA,gBAAA;AAiBJ;AAfI;EANF;IAOI,gBAAA;IACA,cAAA;EAkBJ;AACF;AAhBI;EACE,aAAA;AAkBN;AAfQ;EACE,SAAA;EACA,aAAA;AAiBV;AAbM;EACE,0CAAA;AAeR;AAbQ;EAHF;IAII,oCAAA;EAgBR;AACF;AAZI;EACE,QAAA;EACA,SAAA;EACA,SAAA;AAcN;AAZM;EALF;IAMI,kBAAA;IACA,kBAAA;EAeN;AACF;AAbM;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,yBAAA;EACA,iCAAA;EACA,eAAA;AAeR;AAbQ;EAZF;IAaI,MAAA;IACA,OAAA;IACA,WAAA;IACA,YAAA;IACA,2BAAA;EAgBR;AACF;AAbM;EACE,WAAA;EACA,kBAAA;EACA,qBAAA;EACA,UAAA;EACA,UAAA;EACA,WAAA;EACA,cAAA;EACA,yBDhGQ;ECiGR,0CAAA;EACA,2BAAA;EACA,eAAA;AAeR;AAbQ;EAbF;IAcI,MAAA;IACA,OAAA;IACA,SAAA;IACA,oCAAA;EAgBR;AACF;AAXE;EACE,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,YAAA;AAaJ;AAXI;EAPF;IAQI,YAAA;IACA,gBAAA;IACA,kBAAA;EAcJ;AACF;AAZI;EACE,kBAAA;EACA,gBAAA;EACA,iBAAA;AAcN;AAZM;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,uBAAA;AAcR;AATE;EACE,WAAA;AAWJ;AATI;EAHF;IAII,WAAA;EAYJ;AACF;AATE;EACE,gBAAA;EACA,cAAA;EACA,YAAA;AAWJ;AARE;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,2BAAA;EACA,gBAAA;EACA,gDACE;AASN;AANI;EAVF;IAWI,gBAAA;EASJ;AACF;AAPI;EACE,aAAA;AASN;AANI;EACE,gBAAA;EACA,YAAA;EACA,eAAA;EACA,yDAAA;EACA,4BAAA;EACA,yBAAA;EACA,qDAAA;EACA,mBAAA;EACA,eAAA;AAQN;AALI;EACE,YAAA;EACA,eAAA;AAON;AAHE;EACE,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,mBAAA;AAKJ;AAHI;EAEE,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,UAAA;EACA,SAAA;EACA,UAAA;AAIN;AAAE;EACE,6BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;EACA,SAAA;EACA,UAAA;EACA,SAAA;EACA,eAAA;AAEJ;AAAI;EACE,iBAAA;AAEN;AACI;EACE,gBAAA;AACN;AAEI;EACE,oBAAA;EACA,YAAA;AAAN;AAGI;EACE,oBAAA;AADN;AAKE;EACE,gBAAA;AAHJ;AAKI;EAHF;IAII,gBAAA;EAFJ;AACF;AAII;EACE,aAAA;AAFN;AAOI;EACE,gBAAA;AALN;AAOM;EAHF;IAII,gBAAA;EAJN;AACF;AASI;EAEE,cDpQQ;ECqQR,kBAAA;AARN;AAWI;EAEE,eAAA;AAVN;AAcE;EAEE,gBAAA;EACA,iBAAA;AAbJ;AAgBE;EAEE,iBAAA;EACA,eAAA;AAfJ;AAkBE;EACE,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,gBAAA;AAhBJ;AAoBI;EAEE,aAAA;EACA,oBAAA;EACA,2BAAA;AAnBN;AAqBM;EACE,kBAAA;AAnBR;AAqBQ;EACE,WAAA;EACA,UAAA;EACA,cAAA;EACA,yBDnTM;ECoTN,iBAAA;AAnBV","sourcesContent":["// Fonts\n$font-primary: 'Jost', sans-serif;\n$font-secondary: 'Jost', sans-serif;\n\n// Colors\n$color-primary: #0f0f0f;\n$color-secondary: #ffffff;\n$light-gray: #f0f0f0;\n$gray: #bdbdbd;\n$medium-gray: #8c8c8c;\n$dark-gray: #545454;\n$color-alert: #ed4848;\n\n// Placeholders\n%body-s {\n  font-family: $font-secondary;\n  font-size: 12px;\n  line-height: 18px;\n  letter-spacing: 0.04em;\n}\n\n%body-m {\n  font-family: $font-secondary;\n  font-size: 14px;\n  line-height: 24px;\n  letter-spacing: 0.01em;\n}\n\n%body-l {\n  font-family: $font-secondary;\n  font-size: 18px;\n  line-height: 26px;\n  letter-spacing: 0.01em;\n}\n\n// Animations\n$speed-smooth: 1s;\n$speed-slow: 0.65s;\n$speed-medium: 0.35s;\n$speed-fast: 0.25s;\n$speed-very-fast: 0.15s;\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n","@import \"../../common.scss\";\n\n.product-card {\n  &__container {\n    position: relative;\n    width: calc(100% - 62px);\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: flex-start;\n    margin-left: auto;\n\n    &:not(:first-child) {\n      margin-top: 73px;\n    }\n\n    @media screen and (min-width: 1025px) {\n      width: 100%;\n      max-width: 723px;\n      flex-direction: row;\n      margin-left: auto;\n\n      &:not(:first-child) {\n        margin-top: 57px;\n      }\n    }\n\n    &.hidden {\n      display: none;\n    }\n  }\n\n  &__checkbox {\n    position: absolute;\n    top: 0;\n    left: -51px;\n    padding-top: 50%;\n\n    @media screen and (min-width: 1025px) {\n      position: static;\n      padding-top: 0;\n    }\n\n    input[type=\"checkbox\"] {\n      display: none;\n\n      &:disabled {\n        & + label {\n          margin: 0;\n          display: none;\n        }\n      }\n\n      &:checked + label::after {\n        transform: translate(-50%, -100%) scale(1);\n\n        @media screen and (min-width: 1025px) {\n          transform: translateY(-50%) scale(1);\n        }\n      }\n    }\n\n    label {\n      width: 0;\n      height: 0;\n      margin: 0;\n\n      @media screen and (min-width: 1025px) {\n        position: relative;\n        margin-right: 59px;\n      }\n\n      &::before {\n        content: \"\";\n        position: absolute;\n        top: 100%;\n        left: 100%;\n        width: 16px;\n        height: 16px;\n        display: block;\n        border: 1px solid $color-primary;\n        transform: translate(-50%, -100%);\n        cursor: pointer;\n\n        @media screen and (min-width: 1025px) {\n          top: 0;\n          left: 0;\n          width: 18px;\n          height: 18px;\n          transform: translateY(-50%);\n        }\n      }\n\n      &::after {\n        content: \"\";\n        position: absolute;\n        top: calc(100% - 5px);\n        left: 100%;\n        width: 8px;\n        height: 8px;\n        display: block;\n        background-color: $color-primary;\n        transform: translate(-50%, -100%) scale(0);\n        transition: transform $speed-medium;\n        cursor: pointer;\n\n        @media screen and (min-width: 1025px) {\n          top: 0;\n          left: 0;\n          left: 6px;\n          transform: translateY(-50%) scale(0);\n        }\n      }\n    }\n  }\n\n  &__image {\n    width: 100%;\n    margin-bottom: 14px;\n    flex-basis: auto;\n    flex-shrink: 0;\n    flex-grow: 0;\n\n    @media screen and (min-width: 1025px) {\n      width: 264px;\n      margin-bottom: 0;\n      margin-right: 41px;\n    }\n\n    figure {\n      position: relative;\n      overflow: hidden;\n      padding-top: 100%;\n\n      img {\n        position: absolute;\n        top: 0;\n        left: 0;\n        width: 100%;\n        height: 100%;\n        object-fit: cover;\n        object-position: center;\n      }\n    }\n  }\n\n  &__details {\n    width: 100%;\n\n    @media screen and (min-width: 1025px) {\n      width: auto;\n    }\n  }\n\n  &__meta {\n    flex-basis: auto;\n    flex-shrink: 0;\n    flex-grow: 0;\n  }\n\n  &__inputs {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: flex-start;\n    margin-top: 47px;\n    transition:\n      height $speed-medium 0s,\n      opacity $speed-fast $speed-medium;\n\n    @media screen and (min-width: 1025px) {\n      margin-top: 42px;\n    }\n\n    &.hidden {\n      display: none;\n    }\n\n    select {\n      appearance: none;\n      width: 361px;\n      max-width: 100%;\n      background-image: url(\"../../../public/arrow-down.svg\");\n      background-repeat: no-repeat;\n      background-size: 10px 6px;\n      background-position: calc(100% - 5px) calc(50% - 3px);\n      margin-bottom: 32px;\n      cursor: pointer;\n    }\n\n    input[type=\"text\"] {\n      width: 361px;\n      max-width: 100%;\n    }\n  }\n\n  &__qty-selector {\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n    margin-bottom: 32px;\n\n    input[type=\"text\"] {\n      @extend %body-m;\n      text-align: center;\n      appearance: none;\n      width: 50px;\n      padding: 0;\n      border: 0;\n      outline: 0;\n    }\n  }\n\n  &__qty-change {\n    background-color: transparent;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    height: 24px;\n    width: 24px;\n    padding: 0;\n    border: 0;\n    outline: 0;\n    margin: 0;\n    cursor: pointer;\n\n    &:first-of-type {\n      margin-right: 4px;\n    }\n\n    &:last-of-type {\n      margin-left: 4px;\n    }\n\n    &:disabled {\n      pointer-events: none;\n      opacity: 0.5;\n    }\n\n    svg {\n      pointer-events: none;\n    }\n  }\n\n  &__inputs-recap {\n    margin-top: 53px;\n\n    @media screen and (min-width: 1025px) {\n      margin-top: 32px;\n    }\n\n    &.hidden {\n      display: none;\n    }\n  }\n\n  &__recap {\n    &:not(:first-child) {\n      margin-top: 32px;\n\n      @media screen and (min-width: 1025px) {\n        margin-top: 16px;\n      }\n    }\n  }\n\n  &-recap {\n    &__title {\n      @extend %body-s;\n      color: $medium-gray;\n      margin-bottom: 8px;\n    }\n\n    &__content {\n      @extend %body-m;\n      font-size: 16px;\n    }\n  }\n\n  &__title {\n    @extend %body-m;\n    font-weight: 700;\n    line-height: 17px;\n  }\n\n  &__price {\n    @extend %body-m;\n    line-height: 24px;\n    margin-top: 8px;\n  }\n\n  &__line-info {\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n    margin-top: 12px;\n  }\n\n  &-line {\n    &__single-info {\n      @extend %body-s;\n      display: flex;\n      align-items: stretch;\n      justify-content: flex-start;\n\n      &:not(:last-child) {\n        margin-right: 10px;\n\n        &::after {\n          content: \"\";\n          width: 1px;\n          display: block;\n          background-color: $color-primary;\n          margin-left: 10px;\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
